import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { BackgroundImageDirective } from '@shared/directives/background-image.directive';
import { NgFor, NgClass } from '@angular/common';

@Component({
    selector: 'vertical-slider',
    templateUrl: './vertical-slider.component.html',
    styleUrls: ['./vertical-slider.component.scss'],
    standalone: true,
    imports: [
        NgFor,
        NgClass,
        BackgroundImageDirective,
    ],
})
export class VerticalSliderComponent implements OnInit, AfterViewInit {
  @ViewChild('carouselVertical') carouselVertical: ElementRef;

  @Input() set itemsSlider(items: any[]) {
    this.items = [...items];
  }

  @Input() infinity = false;
  @Output() itemClick = new EventEmitter<number>();

  public items = [];
  private sizeHeight = 0;
  private moveToNext = false;
  private currentItem = 1;

  constructor() {}

  @HostListener('transitionend')
  movePosInitial() {
    const element = this.getELement();
    if (element) {
      if (this.infinity) {
        this.posInitialSlider(element);
        this.moveToNext ? this.moveFirstToEnd() : this.moveEndToFirst();
      }
    }
  }
  ngOnInit() {}

  ngAfterViewInit() {
    this.sizeHeight = this.getSizeItem();
    this.initSlider();
  }

  public nextSlider() {
    const element = this.getELement();
    if (element) {
      if (this.infinity) {
        this.posNextSlider(element);
        this.moveToNext = true;
      } else {
        if (this.currentItem < this.items.length) {
          this.moveToNext = true;
          this.currentItem = this.currentItem + 1;
          this.posNextSlider(element);
        }
      }
    }
  }

  public backSlider() {
    const element = this.getELement();
    if (element) {
      if (this.infinity) {
        this.posBackSlider(element);
        this.moveToNext = false;
      } else {
        if (this.currentItem > 1) {
          this.moveToNext = false;
          this.currentItem = this.currentItem - 1;
          this.posBackSlider(element);
        }
      }
    }
  }

  private getELement() {
    return this.carouselVertical.nativeElement;
  }

  private getSizeItem() {
    const element = this.carouselVertical.nativeElement;
    if (element) {
      let height = element.offsetHeight;
      height = height / 3;
      return height;
    }
    return 0;
  }

  private posInitialSlider(element) {
    element.style.transition = 'none';
    element.style.transform = `translateY(-${this.sizeHeight - 2}px)`;
  }

  private posNextSlider(element) {
    element.style.transition = '.1s';
    if (this.infinity) {
      element.style.transform = `translateY(-${this.sizeHeight * 2 - 2}px)`;
    } else {
      element.style.transform = `translateY(-${
        this.sizeHeight * this.currentItem - 2
      }px)`;
    }
  }

  private posBackSlider(element) {
    element.style.transition = '.1s';
    if (this.infinity) {
      element.style.transform = `translateY(0px)`;
    } else {
      element.style.transform = `translateY(-${
        this.sizeHeight * this.currentItem - 2
      }px)`;
    }
  }

  private initSlider() {
    const element = this.getELement();
    if (element) {
      this.posInitialSlider(element);
    }
  }

  private moveFirstToEnd() {
    const first = this.items.shift();
    this.items.push(first);
  }

  private moveEndToFirst() {
    const end = this.items.pop();
    this.items.unshift(end);
  }
}
